export default __webpack_public_path__ + "static/media/modo_bup.c4b49435.png";